<template>
    <div id="workflow-settings">
        <SupsisButton @click="createWorkflow"> {{ $t('settings.create') }}</SupsisButton>
        <div class="supsis-table">
            <a-table :columns="columns" :data-source="filterWorkflows" :pagination="false" :customRow="customRow">
                <div slot="id" slot-scope="record" style="margin: 0">{{ record.slice(0, 9) }}</div>
                <div slot="name" slot-scope="record" style="margin: 0">{{ record }}</div>
                <div slot="default" slot-scope="record, data" style="margin: 0">
                    <a-checkbox
                        class="supsis-checkbox"
                        v-model="data.default"
                        @change="changeDefaultWorkflow(record, data)"
                    />
                </div>
                <div slot="edit" slot-scope="record, data" style="margin: 0">
                    <div
                        @click="editWorkflow(data)"
                        class="material-icons" style="color: #18bdb5; cursor: pointer"
                    >edit
                    </div>
                </div>
                <div slot="delete" slot-scope="record, data" style="margin: 0">
                    <div
                        @click="deleteWorkflowFunc(data)"
                        class="material-icons" style="color: #ec4b1d; cursor: pointer"
                    >delete
                    </div>
                </div>
            </a-table>
        </div>
        <div class="total-workflow-container">{{ $t('report.total') }}: {{ workflows.length }}</div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import SupsisButton from "../../common/SupsisButton.vue";

export default {
    name: "WorkflowSettings",
    components: {
        SupsisButton,
    },
    data: () => ({

        form: {
            title: null,
            description: null,
            pipelines: [],
        },
    }),
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
            workflows: (state) => state.tasks.workflows,
        }),
        columns() {
            return [
                { title: "ID", dataIndex: "_id", key: "id", scopedSlots: { customRender: "id" } },
                { title: this.$t("task.name"), dataIndex: "title", key: "name", scopedSlots: { customRender: "name" } },
                {
                    title: this.$t("mail.default"),
                    dataIndex: "default",
                    key: "default",
                    scopedSlots: { customRender: "default" },
                },
                {
                    title: this.$t("message.edit"),
                    dataIndex: "edit",
                    key: "edit",
                    scopedSlots: { customRender: "edit" },
                },
                {
                    title: this.$t("ticket.delete"),
                    dataIndex: "delete",
                    key: "delete",
                    scopedSlots: { customRender: "delete" },
                },
            ];
        },
        filterWorkflows() {
            return this.workflows
                .filter((workflow) => {
                    const visibility = workflow.visibility || {};
                    const users = visibility.users || [];
                    const departments = visibility.departments || [];
                    const userSubjects = this.user.subjects || [];
                    const userId = this.user._id || null;
                    if (users.includes(userId) && departments.length === 0) {
                        return true;
                    } else if (departments.some(dept => userSubjects.includes(dept)) && users.length === 0) {
                        return true;
                    } else if (users.includes(userId) || departments.some(dept => userSubjects.includes(dept))) {
                        return true;
                    } else if (users.length === 0 && departments.length === 0) {
                        return true;
                    }
                    return false;
                });
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            setWorkflows: "tasks/setWorkflows",
            updateWorkflow: "tasks/updateWorkflow",
            deleteWorkflow: "tasks/deleteWorkflow",
        }),
        customRow(record) {
            return {
                on: {
                    dblclick: (e) => {
                        this.$router.push(`tasks/workflow/${record.id}/detail`);
                    },
                },
            };
        },
        createWorkflow() {
            this.addNewWindow({
                type: "create-workflow",
            });
        },
        editWorkflow(data) {
            this.$router.push(`tasks/workflow/${data.id}/detail`);
        },
        changeDefaultWorkflow(record, data) {
            const workflows = this.workflows.map((workflow) => {
                workflow.default = false;
                if (workflow.id === data.id) {
                    workflow.default = true;
                }
                return workflow;
            });
            this.setWorkflows(workflows);
            this.updateWorkflow({
                workflowId: data._id,
                params: {
                    default: true,
                },
            });
        },
        deleteWorkflowFunc(data) {
            this.deleteWorkflow(data._id);
        },
    },
    mounted() {
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit("update-form", this.form);
            },
        },
    },
};
</script>
<style lang="scss">
#workflow-settings {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;

    .supsis-table {
        .ant-table-body {
            border: 1px solid #e8e8e8;
        }

        .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
            background-color: #fff4de !important;
        }

        .ant-table-thead > tr > th {
            background-color: transparent !important;
        }

        tr.ant-table-expanded-row {
            background-color: transparent !important;
        }

        .ant-table-row-expand-icon  {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .ant-table-row-expand-icon:focus,
        .ant-table-row-expand-icon:hover {
            color: #ffa800 !important;
            background-color: #fff4de !important;
        }

        .ant-btn:hover,
        .ant-btn:focus {
            color: #ffa800 !important;
            border-color: #ffa800;
        }
    }

    .total-workflow-container {
        padding: 10px;
        border: 1px solid #e6e9f2;
        border-radius: 4px;
    }

    .supsis-checkbox {
        .ant-checkbox-inner {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;

            &::after {
                border: 2px solid #fff;
                left: 20%;
                width: 7px;
                height: 11px;
                border-top: 0;
                border-left: 0;
            }
        }

        .ant-checkbox.ant-checkbox-checked {
            .ant-checkbox-inner {
                border: 3px solid #ec4b1d !important;
                background-color: #ec4b1d !important;
            }
        }

        .ant-checkbox-checked::after {
            border: 1px solid #ec4b1d !important;
        }

        .ant-checkbox-wrapper:hover .ant-checkbox-inner,
        .ant-checkbox:hover .ant-checkbox-inner,
        .ant-checkbox-input:focus + .ant-checkbox-inner {
            border: 1px solid #ec4b1d !important;
        }
    }
}
</style>
